import {useEffect, useState} from 'react';

export function useHandleScroll(): {scrolled: boolean; scrollHeight: number} {
  const [scrolled, setScrolled] = useState(false);
  const [scrollHeight, setScrollHeight] = useState(0);

  useEffect(() => {
    // Set the initial scroll height. This is necessary if the component
    // is mounted after the user has scrolled around on the page
    setScrollHeight(window.scrollY);

    // add an event listener to the window to detect scroll events,
    // this ensures the scroll height is updated as the user scrolls
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setScrolled(scrollPosition >= 60);
      setScrollHeight(scrollPosition);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {scrolled, scrollHeight};
}
